<div class="inline-flex-row align-items-center">
  <app-search-input class="flex-1" [placeholder]="'請輸入紀錄編號 或 中心活動名稱'" [size]="'xl'"
    [action]="searchFilterAction"></app-search-input>

  <button class="icon-button orange ml-5" (click)="restoreEvents()">
    <i class="material-icons-round mb-1">refresh</i>
    <p translate>復原紀錄</p>
  </button>

  <button class="icon-button orange ml-5" (click)="deleteAllPermanently()">
    <i class="material-icons-round mb-1">delete_forever</i>
    <p translate>清空</p>
  </button>
</div>

<div class="inline-flex-row align-items-center mt-3" style="margin-bottom: 1.5rem;">
  <app-service-date-range-filter [action]="dateFilterAction"></app-service-date-range-filter>
  <app-event-type-filter [action]="eventTypeFilterAction" class="ml-4"></app-event-type-filter>
  <app-event-transaction-type-filter [action]="eventTransactionTypeFilterAction"
    class="ml-4"></app-event-transaction-type-filter>
  <app-event-status-filter [action]="statusFilterAction" class="ml-4"></app-event-status-filter>
</div>

<ng-container *ngTemplateOutlet="pagination"></ng-container>


<div class="list-table mt-4 mb-4">
  <div class="list-table-row header">
    <div class="list-table-cell justify-content-center" style="flex-basis: 2rem;flex-grow: 4;">
      <input type="checkbox">
    </div>
    <div class="list-table-cell" style="flex-basis: 5.5rem;flex-grow: 11;">
      <p translate>紀錄編號</p>
      <div class="inline-flex-column" (click)="filters.idOrder = !filters.idOrder;filters.dateOrder = null;fetch()">
        <i class="material-icons-round sort-icon" [ngClass]="{'text-lightgrey': !filters.idOrder}">arrow_drop_up</i>
        <i class="material-icons-round sort-icon" [ngClass]="{'text-lightgrey': filters.idOrder}">arrow_drop_down</i>
      </div>
    </div>
    <div class="list-table-cell" style="flex-basis: 7.5rem;flex-grow: 15;">
      <p translate>活動日期</p>
      <div class="inline-flex-column" (click)="filters.dateOrder = !filters.dateOrder;filters.idOrder = null;fetch()">
        <i class="material-icons-round sort-icon" [ngClass]="{'text-lightgrey': !filters.dateOrder}">arrow_drop_up</i>
        <i class="material-icons-round sort-icon" [ngClass]="{'text-lightgrey': filters.dateOrder}">arrow_drop_down</i>
      </div>
    </div>
    <div class="list-table-cell" style="flex-basis: 5.5rem;flex-grow: 11;">
      <p translate>活動代碼</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 13.5rem;flex-grow: 27;">
      <p translate>中心活動名稱</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 5.5rem;flex-grow: 11;">
      <p translate>交易類型</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 8.5rem;flex-grow: 17;">
      <p translate>尚餘</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 10rem;flex-grow: 20;">
      <p translate>操作</p>
    </div>
  </div>

  <div class="list-table-row" *ngFor="let event of events">
    <div class="list-table-cell justify-content-center align-items-center" style="flex-basis: 2rem;flex-grow: 4;">
      <div class="flex-row justify-content-center align-items-center">
        <input type="checkbox" [(ngModel)]="event.selected" (change)="cacheEvent(event)">
      </div>
    </div>
    <div class="list-table-cell" style="flex-basis: 5.5rem;flex-grow: 11;">
      <p>{{ event.id }}</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 7.5rem;flex-grow: 15;">
      <p matTooltip="{{event.getEventStartDate() | date: 'dd/MM/yyyy'}} - {{event.getEventEndDate() | date: 'dd/MM/yyyy'}}"
        matTooltipPosition="above">{{ event.getEventStartDate() | date: 'dd/MM/yyyy' }} - {{ event.getEventEndDate() |
        date: 'dd/MM/yyyy' }}</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 5.5rem;flex-grow: 11;">
      <p [matTooltip]="event.eventType.code" matTooltipPosition="above">{{ event.eventType.code }}</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 13.5rem;flex-grow: 27;">
      <p [matTooltip]="event.eventName" matTooltipPosition="above">{{ event.eventName }}</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 5.5rem;flex-grow: 11;">
      <p>{{ event.eventPay | translate }}</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 8.5rem;flex-grow: 17;">
      <p>{{ '日' | translate: {value: remainDays - event.deletedDays} }}</p>
    </div>
    <div class="list-table-cell" style="flex-basis: 10rem;flex-grow: 20;">
      <p class="click-text-lightblue flex-0" [routerLink]="['/main/activity/overview/event', event.uuId]" translate>檢視
      </p>
      <p class="click-text-lightblue flex-0 ml-8" (click)="restoreEvent(event.uuId)" translate>還原</p>
      <p class="click-text-lightblue flex-0 ml-8" (click)="deleteEventPermanently(event.uuId)" translate>永久移除</p>
    </div>
  </div>

  <div class="list-table-row" *ngIf="events.length == 0">
    <div class="list-table-cell">
      <p class="text-lightgrey ml-4" translate>沒有紀錄</p>
    </div>
  </div>
</div>


<ng-template #pagination>
  <div class="inline-flex-row align-items-center">
    <div class="inline-flex-row align-items-center flex-1">
      <p translate>已選擇</p>
      <p class="ml-2 mr-2 text-orange">{{ caches.length }}</p>
      <p translate>條紀錄</p>
    </div>

    <p class="click-text-blue mr-8" [ngClass]="{disabled: caches.length == 0}" (click)="deleteEventListPermanently()"
      translate>批量永久移除</p>

    <div class="inline-flex-row" style="margin-right: 1.5rem;">
      <p translate>合計</p>
      <p class="ml-2 mr-2">{{ count }}</p>
      <p translate>項</p>
    </div>

    <div class="pagination mr-4">
      <select class="pagination" [(ngModel)]="filters.itemsPerPage" (change)="filters.page = 1;changePage()">
        <option [ngValue]=5 translate>5 項 / 頁</option>
        <option [ngValue]=10 translate>10 項 / 頁</option>
        <option [ngValue]=20 translate>20 項 / 頁</option>
        <option [ngValue]=30 translate>30 項 / 頁</option>
        <option [ngValue]=50 translate>50 項 / 頁</option>
      </select>
    </div>

    <i class="material-icons-round page-icon" [ngClass]="{'disabled': filters.page <= 1}"
      (click)="filters.page = filters.page - 1;changePage()">chevron_left</i>
    <input type="number" class="page-input" [(ngModel)]="filters.page" (change)="changePage()">
    <p class="ml-3 mr-3 text-grey">/</p>
    <p class="page-number">{{ pages }}</p>
    <i class="material-icons-round page-icon" [ngClass]="{'disabled': filters.page >= pages}"
      (click)="filters.page = +filters.page +1;changePage()">chevron_right</i>
  </div>
</ng-template>